import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as meetingsApi from '../../api/meetings';
const initialState = {
    active: [],
    incoming: [],
    personalIncoming: [],
    loading: false,
    hasNew: false,
    realtimeUnreadIds: [],
};
export const fetchMeetings = createAsyncThunk('meetings/fetchAll', async () => {
    return meetingsApi.getMeetings();
});
const meetingsSlice = createSlice({
    name: 'meetings',
    initialState,
    reducers: {
        setHasNew(state) {
            state.hasNew = true;
        },
        clearNew(state) {
            state.hasNew = false;
        },
        /** Socket: new message arrived for a meeting */
        addUnreadMeeting(state, action) {
            if (!state.realtimeUnreadIds.includes(action.payload)) {
                state.realtimeUnreadIds.push(action.payload);
            }
            // Also mark hasUnread on the meeting in active list
            const meeting = state.active.find((m) => m.id === action.payload);
            if (meeting)
                meeting.hasUnread = true;
        },
        /** User opened a chat — clear real-time unread + mark on meeting object */
        markMeetingRead(state, action) {
            state.realtimeUnreadIds = state.realtimeUnreadIds.filter((id) => id !== action.payload);
            const meeting = state.active.find((m) => m.id === action.payload);
            if (meeting)
                meeting.hasUnread = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchMeetings.pending, (state) => {
            state.loading = true;
        })
            .addCase(fetchMeetings.fulfilled, (state, action) => {
            state.loading = false;
            state.active = action.payload.active;
            state.incoming = action.payload.incoming;
            state.personalIncoming = action.payload.personalIncoming ?? [];
            // Merge real-time unread IDs (socket events that arrived before this fetch)
            for (const id of state.realtimeUnreadIds) {
                const meeting = state.active.find((m) => m.id === id);
                if (meeting)
                    meeting.hasUnread = true;
            }
        })
            .addCase(fetchMeetings.rejected, (state) => {
            state.loading = false;
        });
    },
});
export const { setHasNew, clearNew, addUnreadMeeting, markMeetingRead } = meetingsSlice.actions;
export default meetingsSlice.reducer;
